import React, { useCallback, useState } from 'react';
import { useScheduleFilter } from '../../../../../../data/hooks/schedule/useScheduleFilter';
import SearchBar from '../../../../../elements/SearchBar/SearchBar3';

const SAVED_FILTERS = {};

function ScheduleTextFilter(props) {
    const { eventId } = props,
        [filter] = useScheduleFilter(eventId),
        [init, setInit] = useState(false);

    const handleChange = useCallback(
        (text) => {
            app.store.dispatch(app.actions.program.setFilterText(eventId, text));
        },
        [eventId]
    );

    return <SearchBar value={filter.text || ''} onTextChange={handleChange} autoFocus showClearButton />;
}

export default ScheduleTextFilter;
